import { ArrowRight, Play } from "lucide-react";
import { viewer, useViewer } from "./viewerStore";
import { track } from "./track";

export const BOOTCAMP_URL = "https://orgasmicoffers.com/100kbook";
export const CHALLENGE_URL = "https://orgasmicoffers.com/cc";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Tags the signed-up contact in GoHighLevel when they click an offer button. */
export const reportIntent = (intent) => {
  track(`click_${intent}`);
  const email = viewer.email;
  if (!email) return;
  const body = new Blob([JSON.stringify({ email, intent })], { type: "application/json" });
  if (!navigator.sendBeacon?.(`${API}/leads/intent`, body)) {
    fetch(`${API}/leads/intent`, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
  }
};

export const Micro = ({ children, light }) => <p className={`cta-micro${light ? " light" : ""}`}>{children}</p>;

export const WatchCta = ({ id, children = "Watch the free 60-minute class" }) => (
  <button type="button" className="btn-gold btn-wrap" onClick={viewer.requestPlay} data-testid={id}>
    <Play size={16} fill="currentColor" /> <span>{children}</span> <ArrowRight size={18} />
  </button>
);

export const BootcampCta = ({ id, children = "Start the $100K Book Bootcamp" }) => (
  <a href={BOOTCAMP_URL} onClick={() => reportIntent("bootcamp")} className="btn-gold btn-wrap" data-testid={id}><span>{children}</span> <ArrowRight size={18} /></a>
);

export const DashaCta = ({ id }) => (
  <a href={CHALLENGE_URL} onClick={() => reportIntent("dasha")} className="btn-gold btn-wrap btn-dark" data-testid={id}><span>Do it with Dasha — 8 Week Challenge</span> <ArrowRight size={18} /></a>
);

/* Locked: one Watch button. Unlocked (after sign-up): DIY + With Dasha, plus a quiet watch-again link. */
export const Cta = ({ id, only, bootcampLabel = "DIY — $100K Book Bootcamp", noAgain }) => {
  const { email } = useViewer();
  if (!email) return <WatchCta id={`${id}-watch`} />;
  return (
    <div className="cta-group" data-testid={id}>
      <div className="cta-two">
        {only !== "dasha" && <BootcampCta id={`${id}-bootcamp`}>{bootcampLabel}</BootcampCta>}
        {only !== "bootcamp" && <DashaCta id={`${id}-dasha`} />}
      </div>
      {!noAgain && (
        <button type="button" className="cta-again" onClick={viewer.requestPlay} data-testid={`${id}-again`}>
          <Play size={13} fill="currentColor" /> Start with the free 60-minute video
        </button>
      )}
    </div>
  );
};

export const BOOTCAMP_MICRO = "$100 • 100 DAYS ACCESS • COMPLETE DIY IMPLEMENTATION LIBRARY";
